export default (function () {
    const validations = {

        /**
         * @typedef {Object} Props
         * @property {Function} translate
         */

        /**
         * This checks if the email has been filled.
         *
         * @param {string} email
         * @param {Props} props
         *
         * @returns {void|string}
         */

        email: function (email, formValues, props) {
            const { translate } = props;
            const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (!regex.test(String(email).toLowerCase())) {
                return translate('forms.email');
            }
        },

        /**
         * This checks if the number has been filled.
         *
         * @param {string} value
         * @param {Object} formValues
         * @param {Props} props
         *
         * @returns {void|string}
         */

        number: function (value, formValues, props) {
            const { translate } = props;

            if (isNaN(Number(value))) {
                return translate('forms.number');
            }
        },

        /**
         * This checks if the a value has been filled.
         *
         * @param {string} value
         * @param {Object} formValues
         * @param {Props} props
         *
         * @returns {void|string}
         */
        required: function (value, formValues, props) {
            const { translate } = props;

            if (typeof value === undefined || value === null || (typeof value === 'string' && !value.length)) {
                return translate('forms.required');
            }
        },

        /**
         * This checks if the url is correct.
         *
         * @param {string} value
         * @param {Object} formValues
         * @param {Props} props
         *
         * @returns {void|string}
         */
        url: (value, formValues, props) => {
            const { translate } = props;

            const regex = new RegExp(/^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/);

            if (value && !value.match(regex)) {
                return translate('forms.invalid.url');
            }
        },

        /**
         * This checks if a number or empty has been filled.
         *
         * @param {string} value
         * @param {Object} formValues
         * @param {Props} props
         *
         * @returns {void|string}
         */
        emptyOrNumber: function (value, formValues, props) {
            const { translate } = props;

            if (value && isNaN(Number(value))) {
                return translate('forms.number');
            }
        },

        /**
         * This checks if a string matches the duration format.
         *
         * @param {string} value
         * @param {Object} formValues
         * @param {Object} props
         *
         * @returns {void|string}
         */
        duration: function (value, formValues, props) {
            const { translate } = props;

            const pattern = new RegExp(/^([0-9]+(d|h){1})\s*$/, 'g');

            if (value && !pattern.test(String(value))) {
                return translate('forms.invalid.general');
            }
        },

        /**
         * This checks if a string matches the guid(version 4 uuid) format.
         *
         * @param {string} value
         * @param {Object} formValues
         * @param {Object} props
         *
         * @description Regex from {@link https://www.regextester.com/112609 RegexTester}
         *
         * @returns {void|string}
         */
        guid: function (value, formValues, props) {
            const { translate } = props;

            const pattern = new RegExp(/(\{){0,1}[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(\}){0,1}/, 'g');

            if (value && !pattern.test(String(value))) {
                return translate('forms.invalid.general');
            }
        },
    };

    return validations;
})();



// WEBPACK FOOTER //
// ./src/helpers/forms/validations.js